// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.iki2aUT1AUXwK0 {
  margin-left: var(--ds-space-500, 40px);
}
.b6hNLqLGB3t45H {
  margin: var(--ds-space-0, 0);
  padding: var(--ds-space-0, 0);
  list-style: none;
}
.b6hNLqLGB3t45H li {
  position: relative;
  padding: var(--ds-space-025, 2px) var(--ds-space-0, 0);
  border-bottom: 1px solid var(--ds-border, #091e4224);
}
.b6hNLqLGB3t45H li a {
  display: block;
  position: relative;
  padding: var(--ds-space-075, 6px) var(--ds-space-1000, 80px) var(--ds-space-075, 6px) var(--ds-space-100, 8px);
  border-radius: var(--ds-border-radius-100, 3px);
  color: var(--ds-text, #172b4d);
  text-decoration: none;
}
.b6hNLqLGB3t45H li a:hover {
  border-radius: var(--ds-border-radius-100, 3px);
  background-color: var(--ds-background-neutral, #091e4224);
}
.b6hNLqLGB3t45H li .Vto67uQhYgBtbd {
  margin-bottom: var(--ds-space-0, 0);
  padding: var(--ds-space-0, 0) var(--ds-space-050, 4px) var(--ds-space-0, 0) var(--ds-space-0, 0);
}
.hqVFRLbPCYzjkR {
  padding: var(--ds-space-025, 2px);
  font-size: 16px;
  line-height: 20px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ulGutter": `iki2aUT1AUXwK0`,
	"orgList": `b6hNLqLGB3t45H`,
	"itemName": `Vto67uQhYgBtbd`,
	"itemIcon": `hqVFRLbPCYzjkR`
};
export default ___CSS_LOADER_EXPORT___;
